module.exports = __webpack_public_path__ + "img/92.91941182.jpg";